import { Modal, ModalBody } from "reactstrap";
import TermsContent from "../terms-content";

const TermsModal = ({ open, toggle, onAccept }) => {
  const handleAccept = () => {
    onAccept();
    toggle();
  };

  return (
    <Modal isOpen={open} toggle={toggle} size="lg" centered>
      <div className="gm-modal-header">
        <div className="gm-modal-title-container">
          <div className="gm-modal-title">Términos y Condiciones</div>
        </div>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={toggle}
        />
      </div>
      <ModalBody>
        <div className="gm-checkout-terms-body">
          <TermsContent />
        </div>
      </ModalBody>
      <div className="gm-terms-modal-footer">
        <button
          type="button"
          className="gm-primary-button"
          style={{ minWidth: 160 }}
          onClick={handleAccept}
        >
          Aceptar
        </button>
      </div>
    </Modal>
  );
};

export default TermsModal;
